import {
  TruckJourneyDetail,
  TruckJourneyInfo,
  TruckJourneyLoad,
  TruckJourneyLoadRequest,
  TruckJourneyReorderRequest,
  TruckJourneyRequest,
  TruckJourneyStopRequest,
  TruckJourneysReorderRequest
} from '../models/truck-journey.model';
import { Moment } from 'moment/moment';

export class TruckJourneyRequestMapper {

  public static fromTruckJourneyDetail(truckJourneyDetail: TruckJourneyDetail, carrierId: string): TruckJourneyRequest {
    return TruckJourneyRequestMapper.fromTruckJourneyInfoOrDetail(truckJourneyDetail, carrierId);
  }

  public static fromTruckJourneyInfo(truckJourneyDetail: TruckJourneyInfo, carrierId: string): TruckJourneyRequest {
    return TruckJourneyRequestMapper.fromTruckJourneyInfoOrDetail(truckJourneyDetail, carrierId);
  }

  public static toRequest(
    carrierId: string,
    vehicle: string,
    plannedDepartureFrom: Moment,
    loadAssignments: TruckJourneyLoad[],
    rank: number
  ): TruckJourneyRequest {
    const request = new TruckJourneyRequest();
    request.carrierId = carrierId;
    request.vehicle = vehicle;
    request.plannedPickupDate = plannedDepartureFrom;
    request.loads = loadAssignments.map(load => TruckJourneyRequestMapper.loadRequestFromTruckJourneyLoad(load));
    request.rank = rank;
    return request;
  }

  public static loadRequestFromTruckJourneyLoad(truckJourneyLoad: TruckJourneyLoad): TruckJourneyLoadRequest {
    const loadRequest = new TruckJourneyLoadRequest();
    loadRequest.loadNumber = truckJourneyLoad.loadId;

    let index = 0;
    loadRequest.stops = truckJourneyLoad.stops
      .flatMap(stop => stop.deliveries.map(delivery => {
        const truckJourneyStopRequest: TruckJourneyStopRequest = new TruckJourneyStopRequest();
        truckJourneyStopRequest.deliveryNumber = delivery.number;
        truckJourneyStopRequest.stopType = delivery.stopType;
        truckJourneyStopRequest.stopId = stop.stopId;
        truckJourneyStopRequest.rank = index
        index++;
        return truckJourneyStopRequest;
      }));
    return loadRequest;
  }

  public static truckJourneysReorderFromTruckJourneysInfo(truckJourneys: TruckJourneyInfo[]): TruckJourneysReorderRequest {
    return {order: truckJourneys.map(TruckJourneyRequestMapper.truckJourneyReorderFromTruckJourneyInfo)};
  }

  private static fromTruckJourneyInfoOrDetail(truckJourneyDetail: TruckJourneyInfo|TruckJourneyDetail, carrierId: string): TruckJourneyRequest {
    const request = new TruckJourneyRequest();
    request.id = truckJourneyDetail.id;
    request.carrierId = carrierId;
    request.vehicle = truckJourneyDetail.vehicle;
    request.plannedPickupDate = truckJourneyDetail.plannedPickupDate;
    request.loads = truckJourneyDetail.loads
      ? truckJourneyDetail.loads.map(load => this.loadRequestFromTruckJourneyLoad(load))
      : [];
    request.rank = truckJourneyDetail.rank;
    return request;
  }

  private static truckJourneyReorderFromTruckJourneyInfo(truckJourney: TruckJourneyInfo): TruckJourneyReorderRequest {
    return {id: truckJourney.id, rank: truckJourney.rank};
  }
}
